/*!
 * doTERRA CRM
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import React from 'react';
import { PageProvider, useModalsMutator } from '../../shared/contexts/page';
import { CustomerProvider } from '../../shared/contexts/customer';
import { PaymentsProvider, usePaymentsMutator, usePaymentsState } from '../../shared/contexts/payments';
import { useWindow } from '../../shared/contexts/window';
import { PaymentView } from '../../shared/containers/payment-view';
import { PaymentSelect } from '../../shared/components/payments';
import { Link } from '../../shared/components/controls';
import { useJson } from '../../shared/utils/json';
import { text } from '../../shared/utils/i18n';
import { ErrorModal, Modal } from '../../shared/components/modals';
import {createRoot} from "react-dom/client";
import {getAndStripAttribute} from "../../shared/utils/dom-container-util";

const domContainerId = '#order-payment-panel';
const paymentsModalName = 'order-payments-modal';

const OrderPaymentPanel = (props) => {
    const { model, markets } = props;
    const runEnv = model.digitalWalletRunEnvironment;
    const errorMsgs = model.errorResponseMessage;
    const cardMessage = model.creditCardMessage;
    const googlePayMerchantId = model.googlePayMerchantId;

    const { showModal, hideModal } = usePaymentsMutator();
    const { payments } = usePaymentsState(); //Resolve pop up models twice time.

    const { showGlobalModal, hideGlobalModal } = useModalsMutator();

    const { isMobile } = useWindow();
    const modalSize = isMobile ? 'small' : 'medium';

    if (errorMsgs && payments.length > 0) {
        const modalName = 'payment-error-messages';
        showGlobalModal(modalName, <ErrorModal text={text('checkout.payment.auth.error.newmsg', [errorMsgs])} close={()=>hideGlobalModal(modalName)}/>);
        model.errorResponseMessage = null;
    }

    const showPaymentsModal = (mode = 'list') => {
        showModal(paymentsModalName, <Modal title={text('account.overview.paymentMethods')} ariaMessage={text('account.overview.paymentMethods')} size={modalSize} close={() => hideModal(paymentsModalName)}>
            <PaymentView markets={markets} initialMode={mode} digitalWalletEnv={runEnv} googlePayMerchantId={googlePayMerchantId} modelName={paymentsModalName} cartShippingAddress={model.cartShippingAddress} closeModal={hideModal} citMitMessage={cardMessage} recaptchaKey={model.recaptchaKey}/>
        </Modal>);
    };

    return (
        <>
            {/*NOTE: putting addCard here since the behavior is not currently clear if what add New should do with digital
            wallets. We need to refactor the modes though to allow for just an add mode and potential second parameter to say
            if its a digital wallet or a credit card*/}
            <PaymentSelect showPaymentsModal={() => showPaymentsModal('select')}/>
            <Link id='my-cart-payment-modal' classNames='secondary-link' onClick={showPaymentsModal} value={text('text.mycart.payment.manage')}/>
        </>
    );
};

const MyCartPaymentsContainer = (props) => {
    const { parseJson } = useJson();
    const markets = props.markets;
    const model = parseJson(props.model);
    const customerId = model.customerId || model.uid;
    const activePaymentMethods = model.activePaymentMethods || 'card';

    return (
        <PageProvider>
            <CustomerProvider uid={model.uid} customerId={customerId} language={model.language}>
                <PaymentsProvider context='modal' activePaymentMethods={activePaymentMethods} cartPaymentId={model.cartPaymentId} cartMarketType={model.marketOTGOrNFR} ccNonce={model.ccNonce}>
                    <OrderPaymentPanel markets={markets} model={model}/>
                </PaymentsProvider>
            </CustomerProvider>
        </PageProvider>
    );
};

const domContainer = document.querySelector(domContainerId);
if (domContainer) {
  const markets = getAndStripAttribute('data-markets', domContainer);
  const model = getAndStripAttribute('data-model', domContainer);
  const root = domContainer ? createRoot(domContainer) : false;
  root.render(<MyCartPaymentsContainer markets={markets} model={model}/>);
}
